import { Controller } from "@hotwired/stimulus"

// The panel is a sibling of the select, not a descendant, so it is reached by id rather than as a
// Stimulus target. Initial visibility is server-rendered; this only handles the change.
export default class extends Controller {
  static get values() { return { panelId: String, showWhen: String }; }

  toggle() {
    const panel = document.getElementById(this.panelIdValue);
    panel.style.display = this.element.value === this.showWhenValue ? "" : "none";
  }
}
